<template>
  <div v-if="onReady">
    <slot></slot>
    <small class="text-muted" v-show="totalPages > page +1"> Page {{ page + 1 }} of {{ totalPages }} | {{ totalRecords }} Records </small>
    <div class="d-flex flex-row justify-content-between flex-nowrap">
      <div class="" v-if="pageSizes.length > 0">
        <div class="input-group">
            <div class="input-group-prepend" v-if="screenSizeId >= 3">
              <label class="input-group-text">Page Size</label>
            </div>
            <select :id="'pagination-pages-'+_uid" class="custom-select" v-model="pSize" @change="changePageSize">
              <option v-for="(size, index) in pageSizes" :key="'pagination-option-'+index" :value="size">
                {{ size }}
              </option>
            </select>
        </div>
      </div>
  
      <div class="btn-group" v-show="totalPages > 1">
        <button class="btn btn-outline-secondary" @click.prevent="firstPage" :disabled="!prevPageEnable">
            <i class="fas fa-angle-double-left fa-fw"></i>
        </button>
        <button class="btn btn-outline-secondary" @click.prevent="prevPage" :disabled="!prevPageEnable">
            <i class="fas fa-angle-left fa-fw"></i>
        </button>
        <button class="btn btn-outline-secondary" @click.prevent="nextPage" :disabled="!nextPageEnable">
            <i class="fas fa-angle-right fa-fw"></i>
        </button>
        <button class="btn btn-outline-secondary" @click.prevent="lastPage" :disabled="!nextPageEnable">
            <i class="fas fa-angle-double-right fa-fw"></i>
        </button>
    </div>
    </div>
  </div>
  </template>
  
  <script>
  import onMountedDataProvider from '../../mixins/onMountedDataProvider';
  export default {
    name: 'data-navigation-grid',
    mixins: [onMountedDataProvider],
    props:{
      dataProvider: { required: true, default: null },
      pageSizes: { type: Array, default: () => [10, 20, 50, 100] },
    },
    computed: {
      screenSizeId() {
        return app.layout.screenSizeId;
      },
      page() {
        return this.data_provider_ref?this.data_provider_ref.l_page:0;
      },
      totalRecords(){
        return this.data_provider_ref?this.data_provider_ref.l_totalRecords:0;
      },
      totalPages(){
        return this.data_provider_ref?this.data_provider_ref.totalPages:0;
      },
      pageSize(){
        return this.data_provider_ref?this.data_provider_ref.l_pageSize:0;
      },
      prevPageEnable() {
        return this.page > 0;
      },
      nextPageEnable() {
        return this.page + 1 < this.totalPages;
      }
    },
    methods:{
      changePageSize() {
        this.data_provider_ref.setPageSize(this.pSize);
        this.data_provider_ref.setPage(0, true);
      },
      prevPage() {
        this.data_provider_ref.previousPage(true);
      },
      firstPage() {
        this.data_provider_ref.firstPage(true);
      },
      lastPage() {
        this.data_provider_ref.lastPage(true);
      },
      nextPage() {
        this.data_provider_ref.nextPage(true);
      }
    },
    async mounted(){
      try{
        await this.onMountedDataProvider();
        if (!this.pageSizes.includes(this.pageSize)) {
          this.pageSizes.push(this.pageSize);
        }
        this.pSize = this.pageSize + 0;
      }catch(err){
          console.log(err);
      }
    },
    data(){
      return {
        pSize: 20,
      }
    }
  }
  
  </script>